function buildAccordions(container, headingSelector) {
  const headings = [...container.querySelectorAll(headingSelector)]
    .filter((heading) => heading.parentElement === container);

  for (const heading of headings) {
    const details = document.createElement('details');
    details.className = 'moon-hoard-content-accordion';

    const summary = document.createElement('summary');
    summary.textContent = heading.textContent.trim();

    const content = document.createElement('div');
    content.className = 'moon-hoard-content-accordion__content';

    let sibling = heading.nextSibling;
    while (sibling && !headings.includes(sibling)) {
      const next = sibling.nextSibling;
      content.append(sibling);
      sibling = next;
    }

    details.append(summary, content);
    heading.replaceWith(details);
  }
}

const policy = document.querySelector('.shopify-policy__body');
if (policy) buildAccordions(policy, ':scope > h2, :scope > h3');

const shippingPage = document.querySelector('[data-page-handle="shipping-info"]');
const shippingContent = shippingPage?.querySelector('.rte');
if (shippingContent) {
  buildAccordions(shippingContent, ':scope > h1, :scope > h2, :scope > h3');
}
